export default "ALTER TABLE `credit_cards` ADD `closing_day_to_next_invoice` integer DEFAULT 0 NOT NULL;";